<script setup lang="ts">
import { onMounted, ref } from 'vue';

interface Star {
  top: string;
  left: string;
  animationDelay: string;
}

const stars = ref<Star[]>([]);

onMounted(() => {
  stars.value = Array.from({ length: 80 }, () => ({
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
    animationDelay: `${Math.random() * 4}s`
  }));
});
</script>

<template>
  <div class="starry-background">
    <div v-for="(star, i) in stars" :key="i" class="star" :style="{ top: star.top, left: star.left, animationDelay: star.animationDelay }"></div>
  </div>
</template>

<style scoped>
.starry-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background: linear-gradient(to bottom, #000000, #010314, #000005); */
  overflow: hidden;
}

.star {
  position: absolute;
  width: 2px;
  height: 2px;
  background: white;
  border-radius: 50%;
  animation: twinkle 4s infinite;
}

@keyframes twinkle {
  0%, 100% { opacity: 0; }
  50% { opacity: 1; }
}
</style>
